import React, {

  useEffect,

  useMemo,

  useState,

} from "react";

import I from "../component/Icon";

import BookAddForm from "../component/BookPurchaseForm";

import ConfirmDlg from "../component/ConfirmDialog";

import SB from "../component/SearchBox";

import BookView from "../component/BookPurchaseView";

import apiService from "../services/apiService";

const PAGINATED_TEACHER_BOOK_API =

  "TeacherBookAssign/getPaginatedTeacherBookAssigns";

const DELETE_TEACHER_BOOK_ASSIGN_API =

  "TeacherBookAssign/DeleteTeacherBookAssign";

const TEACHER_API =

  "Teacher/getAllTeacher";

const SCHOOL_API =

  "School/getAllSchool";

const GET_TEACHER_BOOK_BY_ID_API =

  "TeacherBookAssign/getTeacherBookAssignById";

const BOOK_MASTER_API = "BookMaster/getPaginatedBookMasters";

const BOOK_MASTER_BY_ID_API = "BookMaster/getBookMasterById";

const PAGE_SIZE = 10;

const showNotification = (type, message) => {

  if (

    typeof document === "undefined" ||

    typeof window === "undefined"

  ) {

    return;

  }

  const existingNotification =

    document.getElementById(

      "books-page-notification"

    );

  if (existingNotification) {

    existingNotification.remove();

  }

  const notification =

    document.createElement("div");

  notification.id =

    "books-page-notification";

  notification.textContent =

    `${type === "success" ? "✓" : "✕"} ${message}`;

  Object.assign(

    notification.style,

    {

      position: "fixed",

      top: "20px",

      right: "20px",

      zIndex: "99999",

      minWidth: "280px",

      maxWidth: "420px",

      padding: "12px 16px",

      borderRadius: "8px",

      backgroundColor:

        type === "success"

          ? "#d1e7dd"

          : "#f8d7da",

      color:

        type === "success"

          ? "#0f5132"

          : "#842029",

      border:

        type === "success"

          ? "1px solid #badbcc"

          : "1px solid #f5c2c7",

      fontSize: "14px",

      fontWeight: "600",

      boxShadow:

        "0 4px 12px rgba(0,0,0,0.15)",

    }

  );

  document.body.appendChild(

    notification

  );

  window.setTimeout(() => {

    if (notification.parentNode) {

      notification.remove();

    }

  }, 3000);

};

const getApiErrorMessage = (

  error,

  fallback

) => {

  const data =

    error?.response?.data;

  if (

    typeof data === "string" &&

    data.trim()

  ) {

    return data;

  }

  if (

    data &&

    typeof data === "object"

  ) {

    if (

      data?.errors &&

      typeof data.errors === "object"

    ) {

      const validationErrors =

        Object.values(data.errors)

          .flat()

          .filter(Boolean)

          .join(" ");

      if (validationErrors) {

        return validationErrors;

      }

    }

    return (

      data?.failureReason ||

      data?.FailureReason ||

      data?.message ||

      data?.Message ||

      data?.title ||

      data?.error ||

      error?.message ||

      fallback

    );

  }

  return (

    error?.message ||

    fallback

  );

};

const schoolStyleToast = (

  message,

  type

) => {

  const normalizedType =

    String(type || "")

      .trim()

      .toLowerCase();

  const successTypes = [

    "success",

    "suc",

    "ok",

  ];

  showNotification(

    successTypes.includes(

      normalizedType

    )

      ? "success"

      : "error",

    message

  );

};

const getResponseData = (

  response

) => {

  return (

    response?.data ??

    response

  );

};

const extractOutput = (

  result

) => {

  return (

    result?.output ??

    result?.Output ??

    result?.data ??

    result?.Data ??

    result

  );

};

const extractList = (

  output

) => {

  if (

    Array.isArray(output)

  ) {

    return output;

  }

  const candidates = [

    output?.result,

    output?.Result,

    output?.items,

    output?.Items,

    output?.records,

    output?.Records,

    output?.rows,

    output?.Rows,

    output?.data,

    output?.Data,

    output?.list,

    output?.List,

    output?.teachers,

    output?.Teachers,

    output?.schools,

    output?.Schools,

    output?.books,

    output?.Books,

    output?.bookMasters,

    output?.BookMasters,

    output?.teacherBookAssigns,

    output?.TeacherBookAssigns,

  ];

  return (

    candidates.find(

      Array.isArray

    ) || []

  );

};

const isActiveRecord = (

  item

) => {

  const value =

    item?.isActive ??

    item?.IsActive ??

    item?.status ??

    item?.Status;

  if (

    value === undefined ||

    value === null

  ) {

    return true;

  }

  if (

    value === true ||

    value === 1 ||

    value === "1"

  ) {

    return true;

  }

  const text =

    String(value)

      .trim()

      .toLowerCase();

  return (

    text === "true" ||

    text === "active"

  );

};

const extractRowCount = (

  output,

  result,

  list

) => {

  const value =

    output?.rowCount ??

    output?.RowCount ??

    output?.totalRecords ??

    output?.TotalRecords ??

    output?.totalCount ??

    output?.TotalCount ??

    output?.recordCount ??

    output?.RecordCount ??

    result?.rowCount ??

    result?.RowCount ??

    result?.totalRecords ??

    result?.TotalRecords;

  if (

    value !== undefined &&

    value !== null &&

    value !== ""

  ) {

    return (

      Number(value) || 0

    );

  }

  return Array.isArray(list)

    ? list.length

    : 0;

};

const normalizeTeacher = (

  teacher

) => {

  const id =

    teacher?.id ??

    teacher?.Id ??

    teacher?.teacherId ??

    teacher?.TeacherId ??

    0;

  const generatedName = [

    teacher?.firstName ??

    teacher?.FirstName,

    teacher?.middleName ??

    teacher?.MiddleName,

    teacher?.lastName ??

    teacher?.LastName,

  ]

    .filter(Boolean)

    .join(" ")

    .trim();

  const name =

    teacher?.teacherName ??

    teacher?.TeacherName ??

    teacher?.fullName ??

    teacher?.FullName ??

    teacher?.name ??

    teacher?.Name ??

    generatedName ??

    "";

  return {

    ...teacher,

    id,

    name,

  };

};

const normalizeSchool = (

  school

) => {

  return {

    ...school,

    id:

      school?.id ??

      school?.Id ??

      school?.schoolId ??

      school?.SchoolId ??

      0,

    schoolName:

      school?.schoolName ??

      school?.SchoolName ??

      school?.name ??

      school?.Name ??

      school?.school ??

      "",

  };

};

// Resolve names only from TeacherBookAssign / TeacherBookAssignDetail responses.

// Backend must supply BookName per assigned detail for an exact name.

const parseAssignmentDetails = (raw) => {

  if (typeof raw === "string") {

    try { raw = JSON.parse(raw); } catch { return []; }

  }

  return Array.isArray(raw) ? raw : raw && typeof raw === "object" ? [raw] : [];

};

const unwrapAssignmentResponse = (response) => {

  let current = response?.data ?? response;

  for (let i = 0; i < 6; i += 1) {

    if (typeof current === "string") {

      try { current = JSON.parse(current); } catch { return null; }

    }

    if (Array.isArray(current)) return current[0] ?? null;

    if (!current || typeof current !== "object") return null;

    const next = current.output ?? current.Output ?? current.result ?? current.Result ??

      current.data ?? current.Data;

    if (next == null) return current;

    current = next;

  }

  return current;

};

const getAssignmentDetails = (record) => parseAssignmentDetails(

  record?.teaBooAssDetlst ?? record?.TeaBooAssDetlst ??

  record?.teaBooAssDetLst ?? record?.TeaBooAssDetLst ??

  record?.teacherBookAssignDetails ?? record?.TeacherBookAssignDetails ??

  record?.details ?? record?.Details ?? []

);

// Book Name is display-only: saved assignment detail BookId references a BookMaster.

// A master may contain multiple detail book names; use a unique amount match when possible.

const getMasterDetails = (master) => parseAssignmentDetails(

  master?.teaBooAssDetlst ?? master?.TeaBooAssDetlst ??

  master?.bokDetlst ?? master?.BokDetlst ??

  master?.bookMasterDetails ?? master?.BookMasterDetails ??

  master?.details ?? master?.Details ?? []

);

const resolveAssignedName = (item, master) => {

  const direct = String(item?.bookName ?? item?.BookName ??

    item?.assignedBookName ?? item?.AssignedBookName ?? "").trim();

  if (direct) return direct;

  const names = master?.detailBooks ?? [];

  if (names.length === 1) return names[0].bookName;

  if (names.length > 1) {

    const amount = Number(item?.amount ?? item?.Amount);

    const exact = names.filter((b) => Number(b.amount) === amount);

    if (exact.length === 1) return exact[0].bookName;

    // Multiple books share this master ID; show possibilities without guessing.

    return [...new Set(names.map((b) => b.bookName).filter(Boolean))].join(" / ");

  }

  return master?.bookName || "";

};

const normalizeDetail = (

  item,

  bookMap = {}

) => {

  const bookId =

    item?.bookId ??

    item?.BookId ??

    0;

  const qty =

    Number(

      item?.qty ??

      item?.Qty ??

      item?.purchased ??

      item?.Purchased ??

      item?.booksPurchased ??

      item?.BooksPurchased ??

      0

    );

  const returnQty =

    Number(

      item?.returnQty ??

      item?.ReturnQty ??

      item?.returnBooks ??

      item?.ReturnBooks ??

      0

    );

  const description =

    item?.description ??

    item?.Description ??

    item?.notes ??

    item?.Notes ??

    "";

  return {

    ...item,

    id:

      item?.id ??

      item?.Id ??

      0,

    assignBookId:

      item?.assignBookId ??

      item?.AssignBookId ??

      0,

    bookId,

    bookCode:

      item?.bookCode ??

      item?.BookCode ??

      bookMap[String(bookId)]?.bookCode ??

      "",

    bookName:

      resolveAssignedName(item, bookMap[String(bookId)]),

    amount:

      Number(

        item?.amount ??

        item?.Amount ??

        0

      ),

    qty,

    purchased:

      qty,

    booksPurchased:

      qty,

    returnQty,

    returnBooks:

      returnQty,

    returnAmount:

      Number(

        item?.returnAmount ??

        item?.ReturnAmount ??

        0

      ),

    description,

    notes:

      description,

    isActive:

      item?.isActive ??

      item?.IsActive ??

      true,

  };

};

const normalizeTeacherBookAssign = (

  row,

  teacherMap = {},

  schoolMap = {},

  bookMap = {}

) => {

  const assignmentId =

    row?.id ??

    row?.Id ??

    row?.assignBookId ??

    row?.AssignBookId ??

    row?.teacherBookAssignId ??

    row?.TeacherBookAssignId ??

    0;

  const teacherId =

    row?.teacherId ??

    row?.TeacherId ??

    0;

  const teacherMaster =

    teacherMap[

    String(teacherId)

    ];

  const teacherName =

    row?.teacherName ??

    row?.TeacherName ??

    (

      typeof row?.teacher ===

        "string"

        ? row.teacher

        : null

    ) ??

    (

      typeof row?.Teacher ===

        "string"

        ? row.Teacher

        : null

    ) ??

    teacherMaster?.name ??

    "";

  const schoolId =

    row?.schoolId ??

    row?.SchoolId ??

    0;

  const schoolMaster =

    schoolMap[

    String(schoolId)

    ];

  const schoolName =

    row?.schoolName ??

    row?.SchoolName ??

    (

      typeof row?.school ===

        "string"

        ? row.school

        : null

    ) ??

    (

      typeof row?.School ===

        "string"

        ? row.School

        : null

    ) ??

    schoolMaster?.schoolName ??

    "";

  const details = getAssignmentDetails(row).map((item) => normalizeDetail(item, bookMap));

  // -------------------------------------------------------

  // DATE

  // -------------------------------------------------------

  const documentDate =

    row?.documentDate ??

    row?.DocumentDate ??

    row?.purchaseDate ??

    row?.PurchaseDate ??

    "";

  // -------------------------------------------------------

  // STUDENT COUNT

  // -------------------------------------------------------

  const studentCount =

    Number(

      row?.studentCount ??

      row?.StudentCount ??

      row?.students ??

      row?.Students ??

      0

    );

  // -------------------------------------------------------

  // PURCHASED

  // -------------------------------------------------------

  const purchased =

    details.length > 0

      ? details.reduce(

        (

          total,

          item

        ) =>

          total +

          Number(

            item?.purchased ??

            0

          ),

        0

      )

      : Number(

        row?.qty ??

        row?.Qty ??

        row?.purchased ??

        row?.Purchased ??

        row?.booksPurchased ??

        row?.BooksPurchased ??

        0

      );

  // -------------------------------------------------------

  // RETURN

  // -------------------------------------------------------

  const returnBooks =

    details.length > 0

      ? details.reduce(

        (

          total,

          item

        ) =>

          total +

          Number(

            item?.returnBooks ??

            0

          ),

        0

      )

      : Number(

        row?.returnQty ??

        row?.ReturnQty ??

        row?.returnBooks ??

        row?.ReturnBooks ??

        0

      );

  // -------------------------------------------------------

  // BOOK NAMES

  // -------------------------------------------------------

  const bookNames =

    details

      .map(

        (item) =>

          item?.bookName

      )

      .filter(Boolean)

      .join(", ");

  // -------------------------------------------------------

  // BOOK CODES

  // -------------------------------------------------------

  const bookCodes =

    details

      .map(

        (item) =>

          item?.bookCode

      )

      .filter(Boolean)

      .join(", ");

  // -------------------------------------------------------

  // DESCRIPTION

  // -------------------------------------------------------

  const description =

    row?.description ??

    row?.Description ??

    row?.notes ??

    row?.Notes ??

    "";

  // -------------------------------------------------------

  // EDIT FORM BOOKS

  // -------------------------------------------------------

  const booksForForm =

    details.map(

      (item) => ({

        ...item,

        bookId:

          item.bookId,

        bookCode:

          item.bookCode,

        bookName:

          item.bookName,

        amount:

          item.amount,

        purchaseDate:

          documentDate,

        purchased:

          item.purchased,

        students:

          studentCount,

        returnBooks:

          item.returnBooks,

        notes:

          item.description,

      })

    );

  // -------------------------------------------------------

  // FINAL

  // -------------------------------------------------------

  return {

    ...row,

    id:

      assignmentId,

    assignBookId:

      assignmentId,

    teacherId,

    teacher:

      teacherName,

    name:

      teacherName,

    schoolId,

    school:

      schoolName,

    documentNo:

      row?.documentNo ??

      row?.DocumentNo ??

      "",

    documentDate,

    purchaseDate:

      documentDate,

    studentCount,

    students:

      studentCount,

    description,

    notes:

      description,

    totalAmount:

      Number(

        row?.totalAmount ??

        row?.TotalAmount ??

        0

      ),

    bookName:

      bookNames ||

      row?.bookName ||

      row?.BookName ||

      "-",

    bookCode:

      bookCodes ||

      row?.bookCode ||

      row?.BookCode ||

      "",

    purchased,

    booksPurchased:

      purchased,

    returnBooks,

    books:

      booksForForm,

    isActive:

      row?.isActive ??

      row?.IsActive ??

      true,

    status:

      purchased < 40

        ? "critical"

        : purchased < 48

          ? "low"

          : "ok",

  };

};

// =========================================================

// COMPONENT

// =========================================================

export default function BooksPage({

  books = [],

  setBooks,

  schools = [],

  bookMaster = [],

}) {

  // =======================================================

  // PAGE MODE

  // =======================================================

  const [

    sub,

    setSub,

  ] = useState(

    "list"

  );

  const [

    edit,

    setEdit,

  ] = useState(

    null

  );

  const [

    view,

    setView,

  ] = useState(

    null

  );

  const [

    del,

    setDel,

  ] = useState(

    null

  );

  const [

    deleting,

    setDeleting,

  ] = useState(

    false

  );

  // =======================================================

  // API RECORDS

  // =======================================================

  const [

    records,

    setRecords,

  ] = useState(

    []

  );

  // =======================================================

  // SEARCH

  // =======================================================

  const [

    q,

    setQ,

  ] = useState(

    ""

  );

  // =======================================================

  // PAGINATION

  // =======================================================

  const [

    pageNumber,

    setPageNumber,

  ] = useState(

    1

  );

  const [

    totalRecords,

    setTotalRecords,

  ] = useState(

    0

  );

  // =======================================================

  // LOADING

  // =======================================================

  const [

    loading,

    setLoading,

  ] = useState(

    false

  );

  const [

    loadError,

    setLoadError,

  ] = useState(

    ""

  );

  // =======================================================

  // RELOAD

  // =======================================================

  const [

    reloadKey,

    setReloadKey,

  ] = useState(

    0

  );

  // =======================================================

  // MASTER DATA

  // =======================================================

  const [

    masterData,

    setMasterData,

  ] = useState({

    teachers: [],

    schools: [],

    books: [],

    teacherMap: {},

    schoolMap: {},

    bookMap: {},

    ready: false,

  });

  const [

    masterLoading,

    setMasterLoading,

  ] = useState(

    true

  );

  const storedUser = JSON.parse(

    sessionStorage.getItem("user") || "{}"

  );

  const currentTeacherId = Number(

    sessionStorage.getItem("teacherId") ??

    storedUser?.teacherId ??

    storedUser?.TeacherId ??

    0

  );

  const isTeacher = currentTeacherId > 0;

  useEffect(() => {

    let cancelled =

      false;

    const loadMasters =

      async () => {

        try {

          setMasterLoading(

            true

          );

          // =====================================

          // API CALLS

          // =====================================

          const [teacherResponse, schoolResponse, bookResponse] = await Promise.allSettled([

            apiService.get(TEACHER_API),

            apiService.get(SCHOOL_API),

            apiService.post(BOOK_MASTER_API, {

              Page: 1, PageSize: 1000, SearchTerm: "",

              SortDirection: "DESC", SortField: "Id"

            }),

          ]);

          if (teacherResponse.status !== "fulfilled" || schoolResponse.status !== "fulfilled") {

            throw new Error("Unable to load teacher/school data");

          }

          if (

            cancelled

          ) {

            return;

          }

          // =====================================

          // TEACHERS

          // =====================================

          const teacherResult =

            getResponseData(

                teacherResponse.value

            );

          const teacherOutput =

            extractOutput(

              teacherResult

            );

          const teacherList =

            extractList(

              teacherOutput

            )

              .filter(

                isActiveRecord

              )

              .map(

                normalizeTeacher

              )

              .filter(

                (item) =>

                  item?.id

              );

          const teacherMap =

            {};

          teacherList.forEach(

            (teacher) => {

              teacherMap[

                String(

                  teacher.id

                )

              ] = teacher;

            }

          );

          // =====================================

          // SCHOOLS

          // =====================================

          const schoolResult =

            getResponseData(

                schoolResponse.value

            );

          const schoolOutput =

            extractOutput(

              schoolResult

            );

          const schoolList =

            extractList(

              schoolOutput

            )

              .filter(

                isActiveRecord

              )

              .map(

                normalizeSchool

              )

              .filter(

                (item) =>

                  item?.id

              );

          const schoolMap =

            {};

          schoolList.forEach(

            (school) => {

              schoolMap[

                String(

                  school.id

                )

              ] = school;

            }

          );

          // Resolve assigned BookId -> book title from book data.

          // This is for list display only; no assignment data is changed.

          const bookList = bookResponse.status === "fulfilled"

            ? extractList(extractOutput(getResponseData(bookResponse.value)))

            : [];

          const normalizedMasters = bookList.map((b) => ({

            ...b,

            id: b?.id ?? b?.Id ?? b?.bookId ?? b?.BookId,

            bookName: b?.bookName ?? b?.BookName ?? "",

            bookCode: b?.bookCode ?? b?.BookCode ?? "",

          })).filter((b) => b.id != null);

          for (let start = 0; start < normalizedMasters.length; start += 10) {

            const batch = normalizedMasters.slice(start, start + 10);

            await Promise.all(batch.map(async (master) => {

              try {

                const response = await apiService.get(`${BOOK_MASTER_BY_ID_API}/${master.id}`);

                const full = unwrapAssignmentResponse(response);

                const detailBooks = getMasterDetails(full || master)

                  .map((d) => ({

                    bookName: String(d?.bookName ?? d?.BookName ?? "").trim(),

                    amount: Number(d?.amount ?? d?.Amount ?? 0),

                  })).filter((d) => d.bookName);

                master.detailBooks = detailBooks;

              } catch (e) {

                console.warn("Book title lookup unavailable:", master.id, e);

              }

            }));

            if (cancelled) return;

          }

          const bookMap = {};

          normalizedMasters.forEach((master) => { bookMap[String(master.id)] = master; });

          // =====================================

          // STORE

          // =====================================

          setMasterData({

            teachers:

              teacherList,

            schools:

              schoolList,

            books:

              normalizedMasters,

            teacherMap,

            schoolMap,

            bookMap,

            ready:

              true,

          });

        } catch (

        error

        ) {

          console.error(

            "Master Data Load Error:",

            error

          );

          /*

            API मध्ये names direct आले

            तर list तरी load होऊ दे.

          */

          setMasterData({

            teachers: [],

            schools: [],

            books: [],

            teacherMap: {},

            schoolMap: {},

            bookMap: {},

            ready:

              true,

          });

          showNotification(

            "error",

            getApiErrorMessage(

              error,

              "Unable to load master data"

            )

          );

        } finally {

          if (

            !cancelled

          ) {

            setMasterLoading(

              false

            );

          }

        }

      };

    loadMasters();

    return () => {

      cancelled =

        true;

    };

  }, []);

  // =======================================================

  // LOAD PAGINATED TEACHER BOOK ASSIGN

  // =======================================================

  useEffect(() => {

    if (

      !masterData.ready

    ) {

      return;

    }

    let cancelled =

      false;

    const timer =

      setTimeout(

        async () => {

          try {

            if (

              cancelled

            ) {

              return;

            }

            setLoading(

              true

            );

            setLoadError(

              ""

            );

            const payload = {

              Page: Number(pageNumber) || 1,

              PageSize: PAGE_SIZE,

              PageNumber: Number(pageNumber) || 1,

              RowsPerPage: PAGE_SIZE,

              SearchTerm: String(q || "").trim(),

              SortDirection: "DESC",

              SortField: "Id",

              UserId: 0,

              TeacherId: currentTeacherId,

              IsActive: true,

              IncludeInActive: false,

            };

            console.log(

              "Teacher Book Assign Request:",

              payload

            );

            const response =

              await apiService.post(

                PAGINATED_TEACHER_BOOK_API,

                payload

              );

            if (

              cancelled

            ) {

              return;

            }

            // ===================================

            // RESULT

            // ===================================

            const result =

              getResponseData(

                response

              );

            console.log(

              "Teacher Book Assign Response:",

              result

            );

            // ===================================

            // SUCCESS

            // ===================================

            const isSuccess =

              result?.isSuccess ??

              result?.IsSuccess ??

              true;

            if (

              isSuccess ===

              false

            ) {

              throw new Error(

                result

                  ?.failureReason ??

                result

                  ?.FailureReason ??

                result

                  ?.message ??

                result

                  ?.Message ??

                "Unable to load book assignments"

              );

            }

            // ===================================

            // OUTPUT

            // ===================================

            const output =

              extractOutput(

                result

              );

            console.log(

              "Teacher Book Assign Output:",

              output

            );

            // ===================================

            // LIST

            // ===================================

            const list =

              extractList(

                output

              );

            console.log(

              "Teacher Book Assign Raw:",

              list

            );

            // ===================================

            // ONLY ACTIVE ASSIGNMENTS

            // ===================================

            const activeList =

              list.filter((row) => {

                const active =

                  row?.isActive ??

                  row?.IsActive;

                // If API does not return IsActive,

                // keep the record instead of hiding valid rows.

                if (

                  active === undefined ||

                  active === null

                ) {

                  return true;

                }

                return (

                  active === true ||

                  active === 1 ||

                  active === "1" ||

                  String(active)

                    .trim()

                    .toLowerCase() === "true"

                );

              });

            console.log(

              "Teacher Book Assign Active Only:",

              activeList

            );

            // Paginated response may omit assignment details.

            // Fetch them from TeacherBookAssign itself, not BookMaster.

            const expandedList = await Promise.all(activeList.map(async (row) => {

              if (getAssignmentDetails(row).length &&

                  getAssignmentDetails(row).every((d) => d?.bookName || d?.BookName)) return row;

              const id = row?.id ?? row?.Id ?? row?.assignBookId ?? row?.AssignBookId;

              if (!id) return row;

              try {

                const response = await apiService.get(`${GET_TEACHER_BOOK_BY_ID_API}/${id}`);

                const full = unwrapAssignmentResponse(response);

                if (!full || typeof full !== "object") return row;

                const details = getAssignmentDetails(full);

                if (!details.length) {

                  console.warn("No assignment details in getById response:", id, full);

                  return row;

                }

                return { ...row, ...full, teaBooAssDetlst: details };

              } catch (err) {

                console.warn("TeacherBookAssign detail unavailable:", id, err);

                return row;

              }

            }));

            if (cancelled) return;

            const normalized =

              expandedList.map(

                (row) =>

                  normalizeTeacherBookAssign(

                    row,

                    masterData.teacherMap,

                    masterData.schoolMap,

                    masterData.bookMap

                  )

              );

            console.log(

              "Teacher Book Assign Normalized:",

              normalized

            );

            // ===================================

            // ROW COUNT

            // ===================================

            const count =

              extractRowCount(

                output,

                result,

                list

              );

            console.log(

              "Teacher Book Assign RowCount:",

              count

            );

            if (

              cancelled

            ) {

              return;

            }

            // ===================================

            // SET TABLE DATA

            // ===================================

            setRecords(

              normalized

            );

            setTotalRecords(

              count

            );

            /*

              Parent sync optional.

              Effect dependency मध्ये setBooks नाही.

            */

            if (

              typeof setBooks ===

              "function"

            ) {

              setBooks(

                normalized

              );

            }

            // ===================================

            // VALID PAGE

            // ===================================

            const pages =

              Math.max(

                1,

                Math.ceil(

                  count /

                  PAGE_SIZE

                )

              );

            if (

              count > 0 &&

              pageNumber >

              pages

            ) {

              setPageNumber(

                pages

              );

            }

          } catch (

          error

          ) {

            if (

              cancelled

            ) {

              return;

            }

            console.error(

              "Teacher Book Assign API Error:",

              error

            );

            const apiError =

              error

                ?.response

                ?.data;

            let message =

              error?.message ??

              "Unable to load book assignments";

            if (

              typeof apiError ===

              "string"

            ) {

              message =

                apiError;

            } else {

              message =

                apiError

                  ?.failureReason ??

                apiError

                  ?.FailureReason ??

                apiError

                  ?.message ??

                apiError

                  ?.Message ??

                message;

            }

            setLoadError(

              String(

                message

              )

            );

            showNotification(

              "error",

              String(

                message

              )

            );

            setRecords(

              []

            );

            setTotalRecords(

              0

            );

          } finally {

            if (

              !cancelled

            ) {

              setLoading(

                false

              );

            }

          }

        },

        350

      );

    return () => {

      cancelled =

        true;

      clearTimeout(

        timer

      );

    };

  }, [

    q,

    pageNumber,

    reloadKey,

    masterData,

  ]);

  const totalPages =

    Math.max(

      1,

      Math.ceil(

        totalRecords /

        PAGE_SIZE

      )

    );

  const pageNumbers =

    useMemo(() => {

      return Array.from(

        {

          length:

            totalPages,

        },

        (

          _,

          index

        ) =>

          index + 1

      );

    }, [

      totalPages,

    ]);

  const showingFrom =

    totalRecords === 0

      ? 0

      : (

        pageNumber -

        1

      ) *

      PAGE_SIZE +

      1;

  const showingTo =

    totalRecords === 0

      ? 0

      : Math.min(

        pageNumber *

        PAGE_SIZE,

        totalRecords

      );

  // =======================================================

  // SEARCH

  // =======================================================

  const handleSearchChange =

    (

      value

    ) => {

      setQ(

        value

      );

      setPageNumber(

        1

      );

    };

  // =======================================================

  // ADD CALLBACK

  // =======================================================

  const doAdd =

    async (

      data

    ) => {

      console.log(

        "Book Add Completed:",

        data

      );

      setSub(

        "list"

      );

      setPageNumber(

        1

      );

      /*

        Page already 1 असेल तरी

        API refresh.

      */

      setReloadKey(

        (

          previous

        ) =>

          previous + 1

      );

    };

  const doSave = (

    data

  ) => {

    if (!edit) {

      return;

    }

    const purchased =

      data?.books?.reduce(

        (

          total,

          item

        ) =>

          total +

          Number(

            item

              ?.purchased ??

            0

          ),

        0

      ) || 0;

    const returnBooks =

      data?.books?.reduce(

        (

          total,

          item

        ) =>

          total +

          Number(

            item

              ?.returnBooks ??

            0

          ),

        0

      ) || 0;

    const updated = {

      ...edit,

      teacherId:

        data?.teacherId,

      teacher:

        data?.teacher,

      name:

        data?.teacher,

      schoolId:

        data?.schoolId,

      school:

        data?.school,

      books:

        data?.books ??

        [],

      bookName:

        (

          data?.books ??

          []

        )

          .map(

            (item) =>

              item?.bookName

          )

          .filter(

            Boolean

          )

          .join(", "),

      bookCode:

        (

          data?.books ??

          []

        )

          .map(

            (item) =>

              item?.bookCode

          )

          .filter(

            Boolean

          )

          .join(", "),

      purchased,

      booksPurchased:

        purchased,

      returnBooks,

      studentCount:

        Number(

          data

            ?.books?.[0]

            ?.students ??

          edit

            ?.studentCount ??

          0

        ),

      students:

        Number(

          data

            ?.books?.[0]

            ?.students ??

          edit

            ?.studentCount ??

          0

        ),

      description:

        (

          data?.books ??

          []

        )

          .map(

            (item) =>

              item?.notes

          )

          .filter(

            Boolean

          )

          .join(" | "),

      notes:

        (

          data?.books ??

          []

        )

          .map(

            (item) =>

              item?.notes

          )

          .filter(

            Boolean

          )

          .join(" | "),

      status:

        purchased <

          40

          ? "critical"

          : purchased <

            48

            ? "low"

            : "ok",

    };

    setRecords(

      (

        previous

      ) =>

        previous.map(

          (item) =>

            item.id ===

              edit.id

              ? updated

              : item

        )

    );

    showNotification(

      "success",

      "Book record updated successfully!"

    );

    setEdit(

      null

    );

    setSub(

      "list"

    );

  };

  const doDelete = async () => {

    if (!del || deleting) {

      return;

    }

    const recordId = Number(

      del?.id ??

      del?.Id ??

      del?.assignBookId ??

      del?.AssignBookId ??

      0

    );

    if (!recordId) {

      showNotification(

        "error",

        "Invalid Teacher Book Assign Id"

      );

      return;

    }

    try {

      setDeleting(true);

      console.log(

        "Delete Teacher Book Assign ID:",

        recordId

      );

      const response =

        await apiService.delete(

          `${DELETE_TEACHER_BOOK_ASSIGN_API}/${recordId}`

        );

      const result =

        response?.data ??

        response;

      console.log(

        "Delete Teacher Book Assign Success Response:",

        result

      );

      if (

        result?.isSuccess === false ||

        result?.IsSuccess === false

      ) {

        throw new Error(

          result?.failureReason ??

          result?.FailureReason ??

          result?.message ??

          result?.Message ??

          "Delete failed"

        );

      }

      setDel(null);

      showNotification(

        "success",

        result?.message ||

          result?.Message ||

          "Book record deleted successfully!"

      );

      if (

        records.length === 1 &&

        pageNumber > 1

      ) {

        setPageNumber(

          (previous) =>

            Math.max(

              1,

              previous - 1

            )

        );

      } else {

        setReloadKey(

          (previous) =>

            previous + 1

        );

      }

    } catch (error) {

      console.error(

        "Delete Teacher Book Assign Error:",

        error

      );

      console.log(

        "DELETE STATUS:",

        error?.response?.status

      );

      console.log(

        "DELETE RESPONSE DATA:",

        error?.response?.data

      );

      console.log(

        "DELETE RESPONSE:",

        error?.response

      );

      const apiError =

        error?.response?.data;

      let message =

        "Unable to delete book record";

      if (

        typeof apiError ===

        "string"

      ) {

        message = apiError;

      } else if (apiError) {

        message =

          apiError?.failureReason ??

          apiError?.FailureReason ??

          apiError?.message ??

          apiError?.Message ??

          apiError?.title ??

          JSON.stringify(apiError);

      } else if (

        error?.message

      ) {

        message =

          error.message;

      }

      showNotification(

        "error",

        message

      );

    } finally {

      setDeleting(false);

    }

  };

  if (

    sub === "add"

  ) {

    return (

      <BookAddForm

        schools={

          masterData.schools

        }

        allTeachers={

          masterData.teachers

        }

        books={

          masterData.books.length

            ? masterData.books

            : bookMaster

        }

        onSave={

          doAdd

        }

        onBack={() =>

          setSub(

            "list"

          )

        }

        toast={

          schoolStyleToast

        }

      />

    );

  }

  // =======================================================

  // EDIT PAGE

  // =======================================================

  if (

    sub === "edit" &&

    edit

  ) {

    return (

      <BookAddForm

        schools={

          masterData.schools

        }

        allTeachers={

          masterData.teachers

        }

        books={

          masterData.books.length

            ? masterData.books

            : bookMaster

        }

        initial={

          edit

        }

        onSave={

          doSave

        }

        onBack={() => {

          setEdit(

            null

          );

          setSub(

            "list"

          );

        }}

        toast={

          schoolStyleToast

        }

      />

    );

  }

  // =======================================================

  // VIEW PAGE

  // =======================================================

  if (

    sub === "view" &&

    view

  ) {

    return (

      <BookView

        book={

          view

        }

        onBack={() => {

          setView(

            null

          );

          setSub(

            "list"

          );

        }}

        onEdit={() => {

          setEdit(

            view

          );

          setView(

            null

          );

          setSub(

            "edit"

          );

        }}

      />

    );

  }

  // =======================================================

  // SUMMARY

  // =======================================================

  const totalPurchased =

    records.reduce(

      (

        total,

        item

      ) =>

        total +

        Number(

          item

            ?.booksPurchased ??

          item

            ?.purchased ??

          0

        ),

      0

    );

  const totalStudents =

    records.reduce(

      (

        total,

        item

      ) =>

        total +

        Number(

          item

            ?.studentCount ??

          item

            ?.students ??

          0

        ),

      0

    );

  const totalReturnBooks =

    records.reduce(

      (

        total,

        item

      ) =>

        total +

        Number(

          item

            ?.returnBooks ??

          0

        ),

      0

    );

  // =======================================================

  // LIST UI

  // =======================================================

  return (

    <>

      {/* ====================================== */}

      {/* HEADER */}

      {/* ====================================== */}

      <div className="ph">

        <div className="ph-t">

          Books Tracking

        </div>

      </div>

      {/* ====================================== */}

      {/* SUMMARY */}

      {/* ====================================== */}

      <div

        className="mr"

        style={{

          display:

            "flex",

          gap:

            "12px",

        }}

      >

        {[

          [

            totalPurchased,

            "Total Purchased",

            "#EFF6FF",

            "#2563EB",

          ],

          [

            totalStudents,

            "Total Students",

            "#ECFDF5",

            "#10B981",

          ],

          [

            totalReturnBooks,

            "Return Books",

            "#FFF7ED",

            "#EA580C",

          ],

        ].map(

          ([

            value,

            label,

            bg,

            color,

          ]) => (

            <div

              key={

                label

              }

              className="mc"

              style={{

                background:

                  bg,

                width:

                  "180px",

                minWidth:

                  "180px",

                maxWidth:

                  "180px",

                flex:

                  "0 0 180px",

              }}

            >

              <div

                className="mv"

                style={{

                  color,

                }}

              >

                {value}

              </div>

              <div className="ml">

                {label}

              </div>

            </div>

          )

        )}

      </div>

      {/* ====================================== */}

      {/* TOOLBAR */}

      {/* ====================================== */}

      <div className="toolbar">

        <SB

          value={

            q

          }

          onChange={

            handleSearchChange

          }

          placeholder="Search teacher, school, book…"

        />

        {!isTeacher && (

          <button

            type="button"

            className="btn btn-p"

            disabled={masterLoading}

            onClick={() => setSub("add")}

          >

            <I

              n="plus"

              s={13}

              c="#fff"

            />

            Add Book

          </button>

        )}

      </div>

      {/* ====================================== */}

      {/* TABLE */}

      {/* ====================================== */}

      <div className="card">

        <div className="tw">

          <table>

            <thead>

              <tr>

                <th>

                  Teacher Name

                </th>

                <th>

                  School

                </th>

                <th>

                  Book Name

                </th>

                <th>

                  Books Purchased

                </th>

                <th>

                  Return Books

                </th>

                <th>

                  Actions

                </th>

              </tr>

            </thead>

            <tbody>

              {/* ============================== */}

              {/* MASTER LOADING */}

              {/* ============================== */}

              {masterLoading ||

                loading ? (

                <tr>

                  <td

                    colSpan={

                      6

                    }

                    style={{

                      textAlign:

                        "center",

                      padding:

                        30,

                      color:

                        "var(--t3)",

                    }}

                  >

                    Loading book records...

                  </td>

                </tr>

              ) : loadError ? (

                /* ============================== */

                /* ERROR */

                /* ============================== */

                <tr>

                  <td

                    colSpan={

                      6

                    }

                    style={{

                      textAlign:

                        "center",

                      padding:

                        30,

                      color:

                        "#ef4444",

                    }}

                  >

                    {loadError}

                    <div

                      style={{

                        marginTop:

                          12,

                      }}

                    >

                      <button

                        type="button"

                        className="btn btn-g btn-sm"

                        onClick={() =>

                          setReloadKey(

                            (

                              previous

                            ) =>

                              previous +

                              1

                          )

                        }

                      >

                        Retry

                      </button>

                    </div>

                  </td>

                </tr>

              ) : records.length ===

                0 ? (

                /* ============================== */

                /* EMPTY */

                /* ============================== */

                <tr>

                  <td

                    colSpan={

                      6

                    }

                    style={{

                      textAlign:

                        "center",

                      padding:

                        30,

                      color:

                        "var(--t3)",

                    }}

                  >

                    No book records found

                  </td>

                </tr>

              ) : (

                /* ============================== */

                /* DATA */

                /* ============================== */

                records.map(

                  (

                    b,

                    index

                  ) => (

                    <tr

                      key={

                        b?.id ||

                        `${pageNumber}-${index}`

                      }

                      className={

                        b?.status ===

                          "critical"

                          ? "crit"

                          : b?.status ===

                            "low"

                            ? "low"

                            : ""

                      }

                      style={{

                        cursor:

                          "pointer",

                      }}

                      onClick={() => {

                        setView(

                          b

                        );

                        setSub(

                          "view"

                        );

                      }}

                    >

                      {/* TEACHER */}

                      <td className="tdb">

                        {b?.teacher ||

                          "-"}

                      </td>

                      {/* SCHOOL */}

                      <td className="td2">

                        {b?.school ||

                          "-"}

                      </td>

                      {/* BOOK */}

                      <td>

                        <span

                          style={{

                            fontWeight:

                              600,

                            color:

                              "var(--p)",

                          }}

                        >

                          {b?.bookName ||

                            "-"}

                        </span>

                        {b?.bookCode && (

                          <div

                            style={{

                              marginTop:

                                2,

                              fontSize:

                                10,

                              color:

                                "var(--t3)",

                            }}

                          >

                            {b.bookCode}

                          </div>

                        )}

                      </td>

                      {/* PURCHASED */}

                      <td

                        style={{

                          fontWeight:

                            700,

                        }}

                      >

                        {b?.booksPurchased ??

                          b?.purchased ??

                          0}

                      </td>

                      <td

                        style={{

                          fontWeight:

                            700,

                        }}

                      >

                        {b?.returnBooks ??

                          0}

                      </td>

                      {/* ACTION */}

                      <td

                        onClick={(

                          event

                        ) =>

                          event

                            .stopPropagation()

                        }

                      >

                        <div

                          className="ra"

                          style={{

                            display: "flex",

                            alignItems: "center",

                            gap: 6,

                            opacity: 1,

                            visibility: "visible",

                          }}

                        >

                          {/* VIEW - Admin + Teacher */}

                          <button

                            type="button"

                            className="btn btn-g btn-sm"

                            title="View Book"

                            onClick={(event) => {

                              event.stopPropagation();

                              setView(b);

                              setSub("view");

                            }}

                          >

                            <I

                              n="eye"

                              s={11}

                            />

                          </button>

                          {/* EDIT + DELETE - Only Admin */}

                          {!isTeacher && (

                            <>

                              <button

                                type="button"

                                className="btn btn-g btn-sm"

                                title="Edit Book"

                                onClick={(event) => {

                                  event.stopPropagation();

                                  setEdit(b);

                                  setSub("edit");

                                }}

                              >

                                <I

                                  n="edit"

                                  s={11}

                                />

                              </button>

                              <button

                                type="button"

                                className="btn btn-d btn-sm"

                                title="Delete Book"

                                disabled={deleting}

                                onClick={(event) => {

                                  event.stopPropagation();

                                  setDel(b);

                                }}

                              >

                                <I

                                  n="trash"

                                  s={11}

                                />

                              </button>

                            </>

                          )}

                        </div>

                      </td>

                    </tr>

                  )

                )

              )}

            </tbody>

          </table>

        </div>

      <style>{`
        .books-school-pagination {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          min-width: 0;
          max-width: 100%;
          margin-top: 0;
          border-top: 1px solid #eef2f7;
        }
        .books-school-pagination-count {
          flex: 0 0 auto;
          white-space: nowrap;
        }
        .books-school-pagination-controls {
          display: flex;
          align-items: center;
          gap: 5px;
          min-width: 0;
          max-width: 100%;
          flex: 0 1 auto;
        }
        .books-school-pagination-controls > button {
          flex: 0 0 auto;
          height: 32px;
          min-width: 66px;
          padding: 0 10px;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          background: #fff;
          color: #475569;
          font-size: 11px;
          font-weight: 500;
          white-space: nowrap;
          cursor: pointer;
        }
        .books-school-pagination-controls > button:disabled {
          background: #f8fafc;
          color: #cbd5e1;
          cursor: not-allowed;
        }
        .books-school-pagination-pages {
          display: flex;
          align-items: center;
          gap: 4px;
          min-width: 0;
          max-width: 240px;
          overflow-x: auto;
          overflow-y: hidden;
          white-space: nowrap;
          overscroll-behavior-x: contain;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: thin;
        }
        .books-school-pagination-pages > button { flex: 0 0 auto; }
        @media (max-width: 650px) {
          .books-school-pagination { flex-wrap: wrap; }
          .books-school-pagination-controls { flex: 1 1 100%; justify-content: flex-end; }
          .books-school-pagination-pages { flex: 1 1 0; max-width: none; }
        }
      `}</style>
      {!loading && !masterLoading && totalRecords > 0 && (

        <div className="books-school-pagination"

          style={{

            width: "100%",

            minWidth: 0,

            boxSizing: "border-box",

            display: "flex",

            alignItems: "center",

            justifyContent: "space-between",

            gap: 12,

            marginTop: 0,

            padding: "12px 16px 16px",

            borderTop: "1px solid #eef2f7",

          }}

        >

          <div className="books-school-pagination-count"

            style={{

              flex: "0 1 auto",

              minWidth: 0,

              whiteSpace: "nowrap",

              fontSize: 11,

              color: "var(--t3)",

            }}

          >

            Showing <strong>{showingFrom}</strong>–<strong>{showingTo}</strong> of <strong>{totalRecords}</strong>

          </div>

          <div className="books-school-pagination-controls"

            style={{

              display: "flex",

              flex: "0 1 auto",

              minWidth: 0,

              alignItems: "center",

              justifyContent: "flex-end",

              gap: 4,

            }}

          >

            <button

              type="button"


              disabled={pageNumber === 1 || loading}

              onClick={() => setPageNumber((previous) => Math.max(1, previous - 1))}


            >

              ‹ Back

            </button>

            <div

              className="books-school-pagination-pages"
              aria-label="Page numbers"

              style={{

                display: "flex",

                alignItems: "center",

                gap: 4,

                flex: "0 1 auto",

                minWidth: 0,

                maxWidth: 220,

                overflowX: "auto",

                overflowY: "hidden",

                whiteSpace: "nowrap",

                WebkitOverflowScrolling: "touch",

                scrollbarWidth: "thin",

              }}

            >

              {pageNumbers.map((page) => (

                <button

                  key={page}

                  type="button"

                  disabled={loading}

                  aria-label={`Go to page ${page}`}

                  aria-current={pageNumber === page ? "page" : undefined}

                  onClick={() => setPageNumber(page)}

                  style={{

                    height: 32,

                    minWidth: 32,

                    flexShrink: 0,

                    border: pageNumber === page ? "1px solid #2563eb" : "1px solid #e2e8f0",

                    borderRadius: 6,

                    background: pageNumber === page ? "#2563eb" : "#fff",

                    color: pageNumber === page ? "#fff" : "#475569",

                    cursor: loading ? "not-allowed" : "pointer",

                    fontWeight: 600,

                  }}

                >

                  {page}

                </button>

              ))}

            </div>

            <button

              type="button"


              disabled={pageNumber >= totalPages || loading}

              onClick={() => setPageNumber((previous) => Math.min(totalPages, previous + 1))}


            >

              Next ›

            </button>

          </div>

        </div>

      )}

      </div>

      {del && (

        <ConfirmDlg

          title="Delete Book Record"

          msg={`Delete "${del?.bookName ||

            del?.teacher ||

            "this book record"

            }"? This cannot be undone.`}

          onOk={

            doDelete

          }

          onCancel={() => {

            if (

              !deleting

            ) {

              setDel(

                null

              );

            }

          }}

        />

      )}

    </>

  );

}